import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse, LoadState } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RoutineItemOptionInfo } from "./routineItemOptionSlice";
import { routineItemOptionRemove } from "./routineItemOptionInsUpdSlice";

export interface RoutineItemOptionListState {
    state: LoadStateInfo;
    request?: RetrieveRoutineItemOptionListRequest;
    list?: RoutineItemOptionInfo[];
}

const initialState: RoutineItemOptionListState = {
    state: notStarted(),
};


export interface RetrieveRoutineItemOptionListRequest {
    routineId: string;
    //   routineItemId: string;
}
export const retrieveRoutineItemOptionList = createAsyncThunk(
    "retrieveRoutineItemOptionList",
    async (param: RetrieveRoutineItemOptionListRequest, thunkAPI) => {
        console.debug(`retrieve routine item options for routine ${param.routineId}`);

        const response = await fetch(`${getBackendUrl()}/api/routine/${param.routineId}/options`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param: RetrieveRoutineItemOptionListRequest, thunkAPI) => {
            const state = thunkAPI.getState() as RootState;
            const status = state.routineItemOptionList;
            if (!status || !status.state) {
                return true;
            }
            if (status.state.state == LoadState.NotStarted) {
                return true;
            }
            console.debug(`retrieveRoutineItemOptionList skipped: ${status.state.state}`);
            return false;
        }
    }
);


export const routineItemOptionListSlice = createSlice({
    name: "routineItemOptionList",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        check: (state, action: PayloadAction<RetrieveRoutineItemOptionListRequest>) => {
            if (state.state.state != LoadState.NotStarted
                && (state.request && state.request.routineId === action.payload.routineId)
            ) {
                console.trace(`routine item option list already retrieved for routine ${action.payload.routineId}`);
            } else {
                console.debug(`routine item option list not retrieved for routine ${action.payload.routineId}`);
                state.state = notStarted();
                state.request = action.payload;
                state.list = undefined;
            }
        },
        clean: (state) => {
            state.state = notStarted();
            state.list = undefined;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(retrieveRoutineItemOptionList.pending, (state, action) => {
                state.state = loading();
                state.list = undefined;
                state.request = action.meta.arg;
            })
            .addCase(retrieveRoutineItemOptionList.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
                state.list = action.payload;
                state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
            })
            .addCase(retrieveRoutineItemOptionList.rejected, (state, action) => {
                state.state = error(action);
            })
            .addCase(routineItemOptionRemove.fulfilled, (state, action) => {
                if(state.list && action.meta.arg) {
                    state.list = state.list.filter( (item) => item.id !== action.meta.arg?.routineItemOption.id );
                }
            })
            ;
    },
});

// export const { } = routineItemOptionListSlice.actions;

export const selectRoutineItemOptionList = (state: RootState) => state.routineItemOptionList;

export default routineItemOptionListSlice.reducer;
